import React from 'react';
import { IconSvgProps } from '@models/common';

const Success: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.6666 5L7.49992 14.1667L3.33325 10'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Success;
